import {
  createStyles, Slider, Theme, withStyles,
} from '@material-ui/core';

const SliderAction = withStyles(({ palette, breakpoints }: Theme) => createStyles({
  root: {
    marginLeft: '5px',
    // marginTop: '14px',
    color: palette.studio.action,
    height: 12,
    padding: '0 !important',
    minWidth: 120,
    [breakpoints.down(470)]: {
      minWidth: 80,
    },
  },
  thumb: {
    height: 20,
    width: 20,
    backgroundColor: '#fff',
    marginLeft: -12,
    '&:focus,&:hover,&$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 12,
    borderRadius: 6,
  },
  rail: {
    height: 12,
    background: palette.studio.track,
    opacity: 1,
    borderRadius: 6,
  },
}))(Slider);

export default SliderAction;
